import { render, staticRenderFns } from "./text-toggle.vue?vue&type=template&id=7e487583&scoped=true"
import script from "./text-toggle.vue?vue&type=script&lang=ts"
export * from "./text-toggle.vue?vue&type=script&lang=ts"
import style0 from "./text-toggle.vue?vue&type=style&index=0&id=7e487583&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e487583",
  null
  
)

export default component.exports